//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {mergeMap as _observableMergeMap, catchError as _observableCatch} from 'rxjs/operators';
import {Observable, throwError as _observableThrow, of as _observableOf} from 'rxjs';
import {Injectable, Inject, Optional} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import {
  BOKKZ_BASE_URL, ContactPersoon,
  Dienstverlener, FileResponse,
  SwaggerException
} from '@snelstart-ventures/fiscaal/domain-logic';

@Injectable({
  providedIn: 'root'
})
export class BokkzBezwaarClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return default response
   */
  getAllBezwaren(clientId: string): Observable<BezwaarEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/bezwaren/{clientId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllBezwaar(response_);
    }))

      .pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllBezwaar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<BezwaarEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<BezwaarEntity[]>;
    }));
  }

  protected processGetAllBezwaar(response: HttpResponseBase): Observable<BezwaarEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BezwaarEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getOneBezwaar(clientId: string, bezwaarId: string): Observable<BezwaarEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/bezwaar/{clientId}/{bezwaarId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (bezwaarId === undefined || bezwaarId === null)
      throw new Error("The parameter 'bezwaarId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{bezwaarId}", encodeURIComponent("" + bezwaarId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOneBezwaar(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOneBezwaar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<BezwaarEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<BezwaarEntity>;
    }));
  }

  protected processGetOneBezwaar(response: HttpResponseBase): Observable<BezwaarEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BezwaarEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postOneBezwaar(clientId: string, sendToAuthorities: boolean, body?: BezwaarEntity | undefined): Observable<BezwaarEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/bezwaar/{clientId}/{sendToAuthorities}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneBezwaar(response_);
    }))
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpErrorResponse) {
            return _observableThrow(response_);
          }
          return _observableThrow(response_);
        })
      );
  }

  protected processPostOneBezwaar(response: HttpResponseBase): Observable<BezwaarEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BezwaarEntity;
        return _observableOf(resultdefault);
      }));
    }
  }
  /**
   * @return default response
   */
  getSwagger(): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/sst/openapi";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetSwagger(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSwagger(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processGetSwagger(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    }
  }

  /**
   * @return default response
   */
  getExternalGrammar(path: string): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl/{path}";
    if (path === undefined || path === null)
      throw new Error("The parameter 'path' must be defined.");
    url_ = url_.replace("{path}", encodeURIComponent("" + path));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalGrammar(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalGrammar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetExternalGrammar(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }

  /**
   * @return default response
   */
  getWadl(): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWadl(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWadl(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetWadl(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }

}

export interface BezwaarEntity {
  id?: number;
  name?: string;
  lastOpeningDate?: Date,
  submissionDate?: Date,
  bezwaarschrift?: Bezwaarschrift;

  [key: string]: any;
}

export interface Bezwaarschrift {
  naamBelanghebbende?: string;
  bsnBelanghebbende?: string;
  contactPersoon?: ContactPersoon;
  intermediair?: Dienstverlener;
  bezwaarSpecificatie?: BezwaarSpecificatie;

  [key: string]: any;
}

export interface BezwaarSpecificatie {
  dagtekening?: Date;
  aanslagnummer?: string;
  aanslagJaar?: string;
  belastingMiddel?: BezwaarBelastingmiddel;
  bezwaarBox3?: boolean;
  bezwaarOndernemerschapIh?: boolean;
  motivatie?: string;
  bezwaarSoort?: BezwaarSoort;
  bijlagen?: Bijlagen[];

  [key: string]: any;
}

export interface Bijlagen {
  filename: string; //base64 string
  content: string;
}

export enum BezwaarBelastingmiddel {
  OB = "OB",
  IH = "IH",
  VPB = "VPB",
}

export enum BezwaarSoort {
  NHA = "NHA",
  ASLG = "ASLG",
  AMBA = "AMBA",
  BBB = "BBB",
  NVAS = "NVAS",
  BLSR = "BLSR",
  OVER = "OVER",
  VLBS = "VLBS",
}


function throwException(message: string, status: number, response: string, headers: {
  [key: string]: any;
}, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });

}
